import { projectSearchSortType } from '@/Models';
import ProjectCardReprintStamp from '@/Components/ProductCard/ProjectCardReprintStamp.vue';
import Config from '@/Config';

export const ecoSystem = {
    title: 'It\'s the BEST crowdfunding ecosystem for tabletop projects.',
    subtitle: 'Don\'t just take our word for it - check out these 10 facts!',
    items: [{
        icon: 'handshake',
        text: '8 out of the top 10 tabletop creators choose Gamefound.',
    }, {
        icon: 'face-smile-beam',
        text: '87% of creators who switch to Gamefound stick with us.',
    }, {
        icon: 'bolt',
        text: 'Reprint campaigns raise  90% more on average on Gamefound.',
    }, {
        icon: 'ranking-star',
        text: '9 out of the 10 biggest tabletop campaigns in 2025 were on Gamefound.',
        url: Config.helpUrls.blog.year2025Summary,
    }, {
        icon: 'chart-pie',
        text: 'Our Pledge Manager/Late Pledge tools bring in an average of 65% more funding.',
    }, {
        icon: 'money-bill-wave',
        text: 'Over 20 payment methods - more than any other crowdfunding platform.',
        url: Config.helpUrls.help.paymentMethods,
    }, {
        icon: 'rocket-launch',
        text: 'The fastest-growing platform in tabletop crowdfunding: from $46M in 2022 to $190M in 2025 - and over 1.7 million dedicated users.',
    }, {
        icon: 'stretch-pay-icon',
        iconNameSpace: 'ga',
        text: 'Average 33% higher funding for campaigns using Stretch Pay.',
    },
    {
        icon: 'sparkles',
        text: 'A state-of-the-art Pledge Manager that\'s helped manage over 2,000 campaigns in the past 9 years.',
    },
    {
        icon: 'bullseye-arrow',
        text: 'Adfound - an elite marketing tool available to every creator, delivering an average ROAS (Return on Ad Spend) of 5.3x.',
    }],
};

export const quotes = {
    goOnBoard: {
        author: 'Paweł Podgrudny, Go On Board',
        text: 'Gamefound is a user-friendly and dependable choice for any board game creator. It combines great front-end design with efficient back-end systems, making it excellent for showcasing our projects and handling billing and orders.',
    },
    gabeBarrett: {
        author: 'Gabe Barrett',
        text: 'Gamefound isn\'t just the best platform to fund a game; it\'s the best place to build a business. The creator tools, campaign builder, and customer service are as good as it gets.',
    },
    creativeGameStudio: {
        author: 'Creative Game Studio',
        text: 'From day one, we at CGS believed in Gamefound\'s vision and joined the platform during its beta phase, confident it was on the right path. Today, as the leading platform for board game crowdfunding, Gamefound has proven to be a reliable, innovative, and creator-focused partner. Their commitment to the industry and constant evolution make it clear they are not only here to stay - they are just getting started. We\'re proud to be part of that journey.',
    },
    chipTheoryGames: {
        author: 'Josh Wielgus, Chip Theory Games',
        text: 'Gamefound\'s marketing efforts are affordable, effective, and fast! We delivered many assets from our games, and they made tremendous use of them in a huge variety of ads. Definitely highly recommended!',
    },
    hexPloreIt: {
        author: 'Jonathan Mariucci, HEXplore It',
        text: 'Huge commendations to Gamefound for the toolset they\'ve designed and for their outstanding technical support. Gamefound is leagues ahead of its competitor and it shows.',
    },
};

export const buildProjectExplorerTags = (projectTags) => {
    const reprintsData = {
        ['guardsofatlantis2new']: 280,
        ['after-the-empire---deluxe-version-reprint']: 136,
        ['earthborne-rangers-reprint']: 450,
        ['assault-on-doomrock-ultimate-edition']: 116,
        ['gamefound-crowdfunding-campaign']: 500,
    };

    const tags = [
        {
            label: 'Major creators',
            key: 'majorCreators',
            urlName: 'major-creators',
        },
        {
            label: 'First time creators',
            key: 'firstTimers',
            urlName: 'first-timers',
        },
        {
            label: 'Reprints',
            key: 'reprints',
            urlName: 'reprints',
            sortType: projectSearchSortType[projectSearchSortType.newest].name,
            transformResults: (item) => {
                item.customLabels = [{
                    name: 'Reprint',
                    theme: 'default',
                }];

                if (reprintsData[item.projectUrlName]) {
                    item.customItemComponent = ProjectCardReprintStamp;
                    item.customItemComponentProps = {
                        value: reprintsData[item.projectUrlName],
                    };
                }

                return item;
            },
        },
        {
            label: 'Non-board games',
            key: 'nonBoardGame',
            urlName: 'non-board-game',

        },
    ];

    return tags.reduce((acc, tag) => {
        const projectTag = projectTags.find(pc => pc.urlName === tag.urlName);
        if (projectTag) {
            tag.searchParams = {
                projectTags: [projectTag.projectTagID],
                includeRefs: true,
                sortType: tag.sortType || projectSearchSortType[projectSearchSortType.mostPopular].name,
            };
            acc.push(tag);
        }
        return acc;
    }, []);
};